import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Content Safety`}</h2>
    <p>{`The process for moderating Clips reflects GIPHY’s high standard for content safety. Like GIFs and Stickers, all Clips are reviewed by our team of human moderators before appearing in search results. We also provide a rating based on GIPHY’s `}<a parentName="p" {...{
        "href": "https://support.giphy.com/hc/en-us/articles/360058840971-Content-Rating"
      }}>{`Content Rating Guidelines`}</a>{`. Any Clip featuring content that violates GIPHY’s Community Guidelines will be removed from our platform. In addition, in order for Clips content to be included in the search index, the uploader needs to apply for an upgraded GIPHY account and their application must be approved by GIPHY’s moderation team.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      